import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { MondrianButton } from '../components/ui/MondrianButton';
import { MondrianGrid } from '../components/MondrianGrid';
interface LandingPageProps {
  onStart: () => void;
}
export function LandingPage({
  onStart
}: LandingPageProps) {
  return <div className="min-h-screen w-full bg-mondrian-white flex flex-col relative overflow-hidden" data-id="element-248">
      {/* Background Grid - Decorative */}
      <div className="absolute inset-0 opacity-20 pointer-events-none" data-id="element-249">
        <MondrianGrid density="low" animated data-id="element-250" />
      </div>

      {/* Main Content */}
      <main className="flex-1 flex flex-col items-center justify-center relative z-10 px-4" data-id="element-251">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="max-w-4xl w-full bg-white/90 border-8 border-mondrian-black p-8 md:p-16 text-center shadow-[16px_16px_0px_0px_rgba(0,0,0,1)]" data-id="element-252">
          {/* Decorative Top Bar */}
          <div className="flex h-4 mb-12 w-full" data-id="element-253">
            <div className="w-1/3 bg-mondrian-red h-full" data-id="element-254"></div>
            <div className="w-1/3 bg-mondrian-yellow h-full" data-id="element-255"></div>
            <div className="w-1/3 bg-mondrian-blue h-full" data-id="element-256"></div>
          </div>

          <h1 className="text-5xl md:text-7xl font-black mb-6 tracking-tight uppercase" data-id="element-257">
            寻找事物的
            <br data-id="element-258" />
            <span className="text-mondrian-red" data-id="element-259">本质</span>
          </h1>

          <p className="text-xl md:text-2xl text-gray-600 mb-12 font-light" data-id="element-260">
            Finding the Essence of Things
          </p>

          <div className="space-y-8" data-id="element-261">
            <p className="text-lg font-medium max-w-lg mx-auto" data-id="element-262">
              欢迎来到蒙德里安数字实验室。在这里，我们将带你剥去世界的表象，体验新造型主义的纯粹之美。
            </p>

            <MondrianButton variant="yellow" onClick={onStart} className="text-xl px-12 py-6 border-4 shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] hover:translate-y-1 hover:shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] transition-all" data-id="element-263">
              <span className="flex items-center gap-3" data-id="element-264">
                开始体验 <ArrowRight className="w-6 h-6" data-id="element-265" />
              </span>
            </MondrianButton>
          </div>
        </motion.div>
      </main>

      {/* Footer */}
      <footer className="relative z-10 p-8 text-center border-t-4 border-mondrian-black bg-white" data-id="element-266">
        <p className="font-bold" data-id="element-267">
          蒙德里安·现代艺术的几何美学 | Developed by Sharky
        </p>
        <p className="text-sm text-gray-500 mt-2" data-id="element-268">
          The Mondrian Laboratory © 2026
        </p>
      </footer>
    </div>;
}